import type { CSSProperties, FC } from 'react';
import type { ProjectMemberCardId } from '../types';
import {
  CalendarIcon,
  ConnectionsIcon,
  FilesIcon,
  RequestsIcon,
  ToolsIcon,
} from './ProjectMemberIcons';

interface ProjectMemberCabinetGridProps {
  onCardClick: (cardId: ProjectMemberCardId) => void;
  activeCard?: ProjectMemberCardId | null;
}

export const ProjectMemberCabinetGrid: FC<ProjectMemberCabinetGridProps> = ({
  onCardClick,
  activeCard,
}) => {
  const cards = [
    {
      id: 'MY_REQUESTS' as const,
      num: '01',
      title: 'Мои заявки',
      description: 'Назначенные обращения, собственные заявки, статусы и история.',
      icon: RequestsIcon,
      accent: '#49ddb7',
    },
    {
      id: 'PROJECT_CALENDAR' as const,
      num: '02',
      title: 'Календарь',
      description: 'Сроки, встречи, контрольные точки и ближайшие действия.',
      icon: CalendarIcon,
      accent: '#41d2ff',
    },
    {
      id: 'RESEARCH_TOOLS' as const,
      num: '03',
      title: 'Программы и инструменты',
      description: 'Опросы, эксперименты и анализ данных через 36 инструментов.',
      icon: ToolsIcon,
      accent: '#e2ad3a',
    },
    {
      id: 'ACADEMIC_CONNECTIONS' as const,
      num: '04',
      title: 'Академические связи',
      description: 'Рабочая группа, контакты, совместные материалы и сообщения.',
      icon: ConnectionsIcon,
      accent: '#9e80ff',
    },
    {
      id: 'B5_FILES' as const,
      num: '05',
      title: 'Файлы и документы',
      description: 'Файлы проекта, версии, комментарии и результаты.',
      icon: FilesIcon,
      accent: '#5da8ff',
    },
  ];

  return (
    <section style={{ marginTop: 32 }} aria-label="Разделы участника проекта">
      <div style={{ marginBottom: 16 }}>
        <h2 style={{ margin: 0, fontSize: 20, fontWeight: 800 }}>Разделы</h2>
        <p style={{ margin: '4px 0 0', color: '#8faebb', fontSize: 12 }}>
          5 рабочих разделов кабинета «Участник проекта»
        </p>
      </div>

      <div className="owner-hub-grid">
        {cards.map((card) => {
          const Icon = card.icon;
          return (
            <button
              type="button"
              key={card.id}
              id={`card-${card.id}`}
              aria-label={card.title}
              onClick={() => onCardClick(card.id)}
              className={`owner-hub-card${activeCard === card.id ? ' is-opening' : ''}`}
              style={{ '--action': card.accent } as CSSProperties}
            >
              <span className="owner-hub-index">{card.num}</span>
              <span className="owner-hub-icon" aria-hidden="true">
                <Icon className="h-5 w-5" />
              </span>
              <span className="owner-hub-copy">
                <strong>{card.title}</strong>
                <span>{card.description}</span>
              </span>
              <span className="owner-hub-arrow" aria-hidden="true">
                ›
              </span>
            </button>
          );
        })}
      </div>
    </section>
  );
};
